import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { products, categories } from '../data/products';
import ProductCard from '../components/ProductCard';
import './Products.css';

export default function Products() {
  const [searchParams] = useSearchParams();
  const initialCat = searchParams.get('cat') || 'all';
  const [category, setCategory] = useState(initialCat);
  const [filter, setFilter] = useState('all');
  const [sort, setSort] = useState('default');
  const [search, setSearch] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  let filtered = products.filter(p => {
    const catMatch = category === 'all' || p.category === category;
    const filterMatch = filter === 'all' || p.badge === filter;
    const searchMatch = !search || p.name.toLowerCase().includes(search.toLowerCase()) || p.brand.toLowerCase().includes(search.toLowerCase());
    return catMatch && filterMatch && searchMatch;
  });

  if (sort === 'price-low')  filtered = [...filtered].sort((a,b) => a.price - b.price);
  if (sort === 'price-high') filtered = [...filtered].sort((a,b) => b.price - a.price);
  if (sort === 'rating')     filtered = [...filtered].sort((a,b) => b.rating - a.rating);

  return (
    <div className="wrapper products-page">
      <div className="container">
        <div className="page-hero reveal">
          <p className="sec-label">Our Collection</p>
          <h1 className="sec-h2 page-h1">All Products</h1>
          <p className="sec-sub">Browse our full range of premium tech gadgets — all genuine, all delivered across Zimbabwe.</p>
        </div>

        <div className="products-layout">
          {/* SIDEBAR */}
          <aside className="products-sidebar reveal">
            <div className="sidebar-section">
              <div className="sidebar-label">Search</div>
              <div className="sidebar-search">
                <input type="text" placeholder="Search products..." value={search} onChange={e => setSearch(e.target.value)} />
              </div>
            </div>
            <div className="sidebar-section">
              <div className="sidebar-label">Category</div>
              {categories.map(cat => (
                <button key={cat.id} className={`sidebar-cat ${category === cat.id ? 'active' : ''}`} onClick={() => setCategory(cat.id)}>
                  <span>{cat.icon} {cat.name}</span>
                  <span className="sidebar-count">{cat.count}</span>
                </button>
              ))}
            </div>
            <div className="sidebar-section">
              <div className="sidebar-label">Filter</div>
              {[['all','⚡ All'], ['hot','🔥 Hot'], ['new','✨ New'], ['sale','💰 Sale']].map(([val, label]) => (
                <button key={val} className={`sidebar-cat ${filter === val ? 'active' : ''}`} onClick={() => setFilter(val)}>
                  {label}
                </button>
              ))}
            </div>
          </aside>

          {/* GRID */}
          <div className="products-main">
            <div className="products-toolbar">
              <span className="toolbar-count">{filtered.length} products</span>
              <select className="sort-select" value={sort} onChange={e => setSort(e.target.value)}>
                <option value="default">Sort: Featured</option>
                <option value="price-low">Price: Low to High</option>
                <option value="price-high">Price: High to Low</option>
                <option value="rating">Top Rated</option>
              </select>
            </div>
            {filtered.length === 0 ? (
              <div className="empty-state">
                <div>🔍</div>
                <p>No products found</p>
                <p>Try a different filter or search term</p>
              </div>
            ) : (
              <div className="products-grid-full">
                {filtered.map((p, i) => <ProductCard key={p.id} product={p} delay={i * 0.04} />)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
